<template>
    <div class="form-row mb-3 sm:col-span-4">
        <label :for="id" class="block text-sm font-black leading-6 text-left text-white">{{ label }}</label>
        <slot></slot>
    </div>
</template>
  
<script>
export default {
    props: {
        label: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
    },
};
</script>
  
<style>
/* Whatever field goes in the slot sits 0.25rem under its label */
.form-row > :not(label) {
    @apply mt-1;
}
</style>